import styled from 'styled-components'

export const PatientNeedsToContinueTreatmentContainer = styled.div`
  width: 100%;
`

export const RadioButtonOptions = styled.div`
  margin-top: 12px;

  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
`

export const InputWrapper = styled.div`
  margin-top: 10px;
`

export const SelectWrapper = styled.div`
  margin-top: 10px;
  div {
    margin-top: 0;
    max-width: none;
  }
`

export const TextAreaLengthDisplay = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-top: 10px;

  p {
    color: #898989;
  }
`
